<template lang="pug">
  app-plotly(nomeDiv="graficoMensal", :dados="graficoDados", :layout="layout")
</template>

<script>
import AppPlotly from '@/components/AppPlotly'
import { meses } from '../../../utils/constantes'

export default {
  components: {
    AppPlotly
  },

  props: {
    produtividadeUsuario: {
      required: true
    },
    mediasWithDataArray: {
      required: true
    }
  },

  data () {
    return {
      loading: true,
      mediaServidores: null,
      media: null
    }
  },

  mount () {
    this.createMapMedia()
    this.media = this.mediasWithDataArray
  },

  computed: {
    graficoDados () {
      if (_.isEmpty(this.produtividadeUsuario) || _.isEmpty(this.mediasWithDataArray)) { // eslint-disable-line
        return []
      }

      this.createMapMedia()

      const graficoDados = [
        {
          x: [],
          y: [],
          hoverinfo: 'y',
          marker: {
            color: []
          },
          type: 'bar',
          showlegend: false
        },
        {
          x: [0, 0, 0],
          y: [0, 0, 0],
          name: 'Acima da Média',
          marker: {
            color: '#28A1CB'
          },
          showLegend: true,
          visible: 'legendonly',
          type: 'bar'
        },
        {
          x: [0, 0, 0],
          y: [0, 0, 0],
          name: 'Abaixo da Média',
          marker: {
            color: '#D54D54'
          },
          showLegend: true,
          visible: 'legendonly',
          type: 'bar'
        },
        {
          x: [],
          y: [],
          name: 'Média',
          hoverinfo: 'y',
          line: {
            shape: 'spline'
          },
          marker: {
            color: 'rgb(242, 167, 75)'
          }
        }
      ]
      for (let index = 1; index < this.produtividadeUsuario.length; index++) {
        // Monta o eixo dos meses
        for (let i = 0; i < graficoDados.length; i++) {
          const data = this.produtividadeUsuario[index]

          graficoDados[i].x.push(meses.get(data.mes) + '/' + data.ano)
        }

        // Monta o grafico de linhas das medias
        graficoDados[3].y.push(this.getMediaGeral(parseInt(this.produtividadeUsuario[index].mes)))

        // Verifica se a produtividade do técnico é maior ou igual que a media de produtividade dos técnicos de um setor
        // Caso verdadeiro, adiciona no array a produtividade e seta sua cor, para indicar que está acima da media
        // Caso contrario, insere no array, e colocar sua cor para de indicar que está abaixo
        if (this.isInMedia(this.produtividadeUsuario[index].produtividade, parseInt(this.produtividadeUsuario[index].mes))) {
          graficoDados[0].y.push(this.produtividadeUsuario[index].produtividade)
          graficoDados[0].marker.color.push('#28A1CB')
        } else {
          graficoDados[0].y.push(this.produtividadeUsuario[index].produtividade)
          graficoDados[0].marker.color.push('#D54D54')
        }
      }

      return graficoDados
    },
    hasData () {
      return !_.isEmpty(this.dados)// eslint-disable-line
    },

    layout () {
      return {
        xaxis: {
          title: 'Mês',
          tickfont: {
            size: 14,
            color: 'rgb(107, 107, 107)'
          },
          automargin: true
        },
        yaxis: {
          title: 'Produtividade',
          titlefont: {
            size: 16,
            color: 'rgb(107, 107, 107)'
          },
          tickfont: {
            size: 14,
            color: 'rgb(107, 107, 107)'
          }
        },
        bargap: 0.2,
        barmode: 'group',
        legend: {
          itemclick: false,
          itemdoubleclick: false,
          font: {
            color: 'rgba(0, 0, 0, 1)'
          }
        }
      }
    }
  },

  methods: {
    getMediaGeral (index) {
      const produtividade = this.mediaServidores.get(index)
      if (produtividade && produtividade.mediaProdutividade) {
        const servidores = this.$route.query.idsServidores.length
        return (produtividade.mediaProdutividade / servidores).toFixed(2)
      }
      return 0
    },
    createMapMedia () {
      let mediaMensalHash = new Map()
      this.mediasWithDataArray.forEach(element => {
        mediaMensalHash.set(parseInt(element.mes), element)
      })
      this.mediaServidores = mediaMensalHash
    },
    isInMedia (produtividade, index) {
      if (produtividade === undefined || !this.mediaServidores.get(index)) { return false }
      return produtividade >= this.getMediaGeral(index)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/produtividade/components/GraficoMensal.vue